export let hres6euColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '55',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'typwrk_codshift',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 400px;',
      headerRow: 1,
      colspan: 4,
      rowspan: 1
    }, {
      key: 'codshift_o',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 200px;',
      headerRow: 2,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'codshift_n',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 200px;',
      headerRow: 2,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'typwrk_codshift_o',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 3,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'typwrkr_codshiftr_o',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 3,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'typwrk_codshift_n',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 3,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'typwrkr_codshiftr_n',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;',
      headerRow: 3,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '160',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '170',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6EUC1',
      labelIndex: '180',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}

export let hres6euMaxRowspan = {
  index: 3
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6eu.js